import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { TableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLables = {
  aifm_reporting_code: {
    name: 'AIFM reporting code',
    order: 16
  },
  aifm_jurisdiction: {
    name: 'AIFM Jurisdiction',
    order: 17
  },
  aifm_national_code: {
    name: 'AIFM National Code',
    order: 18,
    disabled: true
  },
  aifm_name: {
    name: 'AIFM name',
    order: 19
  },
  aifm_eea_flag: {
    name: 'AIFM EEA Flag',
    order: 20
  },
  aifm_no_reporting_flag: {
    name: 'AIFM no reporting flag',
    order: 21
  }
};

export const FundIdentificationCodes3AIF001 = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.MAIN_INFO,
    onChangeFund,
    schema: schema.MAIN_INFO,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MAIN_INFO?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'MAIN_INFO'
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.MAIN_INFO?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.MAIN_INFO?.find(item => item?.errors?.general)
    ?.errors?.general;

  return (
    <>
      <Errors id="reporttables-fund-identification-codes-3-aif001-errors">
        {isRequiredTable && (
          <li id="reporttables-fund-identification-codes-3-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li
            key={item.msg}
            id={`reporttables-fund-identification-codes-3-aif001-error-${idCreator(item.msg)}`}
          >
            {item.msg}
          </li>
        ))}
      </Errors>

      <Table
        id="reporttables-fund-identification-codes-3-aif001-table"
        handleChanges={onChange}
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        columns={columns}
        rows={rows}
      />
    </>
  );
};
